import template from './CartDropdownComponent.html';
import store from '../../store/store';

export default {
  template,

  data() {
    return {
      sharedState: store, // Do not modify this directly – this is only for convenience in templates.
      showTooltip: false,
      tooltipWasShown: false,
      timer: null,
    };
  },

  computed: {
    shouldShowTooltip() {
      return !this.tooltipWasShown && this.showTooltip;
    },
    cartItemsLength() {
      return this.sharedState.cart.items.length;
    },
  },

  watch: {
    cartItemsLength(val, oldVal) {
      if (val > 0 && oldVal === 0) {
        this.showTooltip = true;
      }
    },
    showTooltip(val) {
      if (val === true && !this.timer) {
        this.timer = setTimeout(() => {
          this.showTooltip = false;
          this.tooltipWasShown = true;
          this.timer = null;
        }, 5000);
      }
    },
  },
};
